import { ReactNode } from "react";

interface CardProps {
  title?: string;
  badge?: string;
  badgeType?: "auto" | "edit";
  className?: string;
  children: ReactNode;
}

const Card = ({ title, badge, badgeType = "auto", className = "", children }: CardProps) => {
  return (
    <div className={`card ${className}`.trim()}>
      {title ? (
        <div className="cardTitle">
          {title}
          {badge ? (
            <span className={badgeType === "edit" ? "editBadge" : "autoBadge"}>
              {badge}
            </span>
          ) : null}
        </div>
      ) : null}
      {children}
    </div>
  );
};

export default Card;
